module.exports = __webpack_public_path__ + "static/media/iphone-11.d09a62f1.glb";